export { default as MortgageFeeSlot } from './MortgageFeeSlot';
